import type { Land } from '@dobrozem/sdk';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { Text } from '@/components/Text';
import styles from './index.module.scss';
const Chart = dynamic(() => import('react-charts').then(mod => mod.Chart), {
  ssr: false
});
type ChartType = 'maxTemperature' | 'minTemperature' | 'ndvi' | 'rainfall';
const chartTypeDictionary: Record<ChartType, string> = {
  maxTemperature: 'Максимальна температура',
  minTemperature: 'Мінімальна температура',
  ndvi: 'NDVI',
  rainfall: 'Опади'
};
const resizeArray = <T,>(array: T[], lengthTo: number): T[] => {
  // Calculate the step size
  const stepSize = array.length / lengthTo;

  // Create the new array with proportional elements
  const newArray: T[] = [];
  for (let i = 0; i < lengthTo; i++) {
    const index = Math.round(i * stepSize);
    newArray.push(array[index]);
  }
  return newArray;
};
export const Charts = ({
  statistics
}: {
  statistics: Land['statistics'];
}) => {
  const [chartType, setChartType] = useState<ChartType>('rainfall');
  const axes = [{
    position: 'bottom',
    primary: true,
    stacked: true,
    type: chartType === 'ndvi' ? 'time' : 'linear'
  }, {
    position: 'left',
    stacked: true,
    type: 'linear'
  }];
  const weather = resizeArray(statistics?.weather ?? [], 35);
  const ndvi = resizeArray(statistics?.ndvi ?? [], 20);
  const data = [{
    data: chartType === 'ndvi' ? ndvi.map(item => ({
      primary: new Date(item.date).getTime(),
      secondary: item.average
    })) : weather.map((item, index) => ({
      primary: index,
      secondary: item[chartType]
    }))
  }];
  const getSeriesStyle = () => ({
    color: `#479CEF`,
    opacity: 0.7
  });
  const gradientSVG = Object.freeze({
    svg: <defs>
        <linearGradient id='offer' x1='0' x2='0' y1='1' y2='0'>
          <stop offset='0%' stopColor='#479CEF' stopOpacity={0.1} />
          <stop offset='100%' stopColor='#479CEF' />
        </linearGradient>
      </defs>
  });
  const renderGradient = () => {
    return gradientSVG.svg;
  };
  return <div className={styles['schedule']} data-sentry-component="Charts" data-sentry-source-file="index.tsx">
      <Text type='p3' data-sentry-element="Text" data-sentry-source-file="index.tsx">Динаміка польових показників</Text>
      <div className={styles['schedule-wrapper']}>
        <div className={styles['tabs-wrapper']}>
          {(Object.entries(chartTypeDictionary) as [ChartType, string][]).map(([type, title], index) => <div className={styles['tab-item']} key={index} onClick={() => setChartType(type)}>
                <div className={clsx(styles['round'], type === chartType && styles.isActive)}></div>
                <Text type='p3'>{title}</Text>
              </div>)}
        </div>
        <div className={styles['chart-wrapper']}>
          <Chart axes={axes} data={data} getSeriesStyle={getSeriesStyle} renderSVG={renderGradient} series={{
          type: 'area'
        }} data-sentry-element="Chart" data-sentry-source-file="index.tsx" />
        </div>
      </div>
    </div>;
};